export default __webpack_public_path__ + "895cea0ee5ad00353837329fb65a9faf.png";